import { render, staticRenderFns } from "./TimeAccess.vue?vue&type=template&id=46e604f3&"
import script from "./TimeAccess.vue?vue&type=script&lang=js&"
export * from "./TimeAccess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports